// Not used anywhere

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import _ from 'lodash';

if (environment.production) {
	enableProdMode();
}

if (document.querySelector('menu-navigation')) {
	platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));
}

_.noConflict();
